import styled from 'styled-components';
import { device } from '../media_queries';

const GCMain = styled.div`
  width: ${props => props.largew ? "100%" : "35%"};
  /* ${props => props.width}; */
  /*  */
  height: ${props => props.large ? "30%" : "310px"};
  /* ${props => props.height}; */
  /* */
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  border-radius: 6px;
  box-shadow: 0 7px 64px 0 rgba(0, 0, 0, 0.07);
  background-color: #FBFEFE;
  /* margin: 0 1%; */
  /* margin-top: 1.5%; */
  @media ${device.mobileS} {

  }
  @media ${device.tablet} {
    
  }
  @media ${device.laptop} {

  }
  @media ${device.desktop} {
    
  }
`;

const GCIcon = styled.img`
  width: 20px;
  height: 20px;
  position: absolute;
  float: left;
  align-self: flex-start;
  cursor: pointer;
  @media ${device.mobileS} {

  }
  @media ${device.tablet} {
    
  }
  @media ${device.laptop} {

  }
  @media ${device.desktop} {
    
  }
`;

const GCTitle = styled.h2`
  width: 100%;
  font-size: 1rem;
  font-weight: 600;
  text-align: right;
  /* margin: 0; */
  margin: 2% 3% 2% 0;
  @media ${device.mobileS} {

  }
  @media ${device.tablet} {
    
  }
  @media ${device.laptop} {

  }
  @media ${device.desktop} {
    
  }
`;

const GCSubTitle = styled.h4`
  width: 100%;
  font-size: .75rem;
  font-weight: 400;
  text-align: right;
  margin: 0 3% 3% 0;
  /* margin: 3% 6% 0 0; */
  @media ${device.mobileS} {

  }
  @media ${device.tablet} {
    
  }
  @media ${device.laptop} {

  }
  @media ${device.desktop} {
    
  }
`;

const GCDescription = styled.h2`
  width: 90%;
  font-size: .5rem;
  font-weight: normal;
  text-align: center;
  /* margin: 3% 6% 0 0; */
  @media ${device.mobileS} {

  }
  @media ${device.tablet} {
    
  }
  @media ${device.laptop} {

  }
  @media ${device.desktop} {
    
  }
`;

export { GCMain, GCIcon, GCTitle, GCSubTitle, GCDescription };